import { Spinner } from '@heroui/react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';
import ApiClientOpen from '@/services/api/axios/apiClientOpen';
import { useEffect, useRef } from 'react';
import { getEmpresaUsuarioByUsuarioId } from '@/services/empresa/users.service';


//este authValidator aplica solo para cuenta oAuth2
//para el proceso usuario contraseña se debe aplicar logica de servicio y locastorage
const AuthValidator =  () => {
  const [searchParams] = useSearchParams();
  const access_token = searchParams.get('access_token');
  // const error = searchParams.get('error');
  const provider = searchParams.get('provider');
  const navigate = useNavigate();
  
  // Use a ref to ensure the auth flow runs only once even with StrictMode
  const hasExecutedRef = useRef(false);

  useEffect(() => {
    if (hasExecutedRef.current) return; // Prevent execution in StrictMode's second call
    hasExecutedRef.current = true;

    const handleAuth = async () => {
      try {
        if (access_token) {
          let callbackEndpoint = 'google';
          if (provider) {
            callbackEndpoint = provider;
          }

          const response = await ApiClientOpen.get(`/auth/${callbackEndpoint}/callback?access_token=${access_token}`);
          
          if (response.status === 200) {
            //debo consultar empresa-usuario
            const EmpresaUsuario = await getEmpresaUsuarioByUsuarioId(response.data.user.id);
            //si la empresa no existe y si el usuarios es un superadmin entoncse
            //asignar empresa al usuario en el store
            const empresaParaStore = {...response.data.user, empresa: EmpresaUsuario?.empresa ?? null };
            useAuthStore.getState().setCredentials(response.data.jwt, empresaParaStore);
          } else {
            console.error('Error fetching auth callback:', response.statusText);
          }

          let userTokens = await ApiClientOpen.get('/user-tokens?filters[user][$eq]='+response.data.user.id)
          
          if(userTokens.data.data.length === 0){
            await ApiClientOpen.post('/user-tokens', {
              data:{
                accessToken: access_token,
                provider: 'google',
                user: response.data.user.id,
              }
            })
          }
          else{
            await ApiClientOpen.put('/user-tokens/'+userTokens.data.data[0].documentId, {
              data:{
                accessToken: access_token,
                provider: 'google',
                user: response.data.user.id,
              }
            })
          }

          if(useAuthStore.getState().user?.empresa){
            navigate('/');
          }else{
            navigate('/onboarding');
          }

        }
      } catch (err) {
        console.error('Authentication error:', err);
        navigate('/');
      }
    };

    handleAuth();
  }, [access_token, provider, navigate]);

  return (
   <Spinner size="lg" className="m-10" />
  );
};

export default AuthValidator;